// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".table-container[data-v-f2fbe95c]{width:100%;overflow-x:scroll}.table-container .v-data-table[data-v-f2fbe95c]{width:auto}", "",{"version":3,"sources":["/Users/niwashouta/projects/kgi_sfa/app/javascript/erp_src/view/ledger/LedgerShowPage.vue"],"names":[],"mappings":"AACA,kCACC,UAAA,CACA,iBAAA,CACA,gDACC,UAAA","file":"LedgerShowPage.vue","sourcesContent":["\n.table-container {\n\twidth: 100%;\n\toverflow-x: scroll;\n\t.v-data-table {\n\t\twidth: auto;\n\t}\n}\n"]}]);
// Exports
module.exports = exports;
